import { createPropertySelectors, createSelector } from '@ngxs/store';

import { SeatsStateModel, SeatsState } from './seats.state';

export class SeatsStateSelectors {
  static slices = createPropertySelectors<SeatsStateModel>(SeatsState);

  static getSelectedSeatId = createSelector(
    [SeatsStateSelectors.slices.selectedSeat],
    (selectedSeat) => selectedSeat
  );

  static seatsById = createSelector(
    [SeatsStateSelectors.slices.seats],
    ({ byId }) => byId
  );

  static getSeatById = createSelector(
    [SeatsStateSelectors.seatsById],
    (seatsById) => (seatId: number) => seatsById[seatId]
  );

  static isSeatSelected = createSelector(
    [SeatsStateSelectors.getSelectedSeatId],
    (selectedSeatId) => !!selectedSeatId
  );

  static getSelectedSeat = createSelector(
    [SeatsStateSelectors.getSelectedSeatId, SeatsStateSelectors.seatsById],
    (selectedSeatId, seatsById) => seatsById[selectedSeatId]
  );
}
